// Refund authority as the Admin sets it on the employee authority master. The server enforces it on every
// refund; these helpers only shape the form values.

export const MAX_REFUND_ENTRY = 10000000;

const toAmount = (value) => {
  const n = parseFloat(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

/** The three refund fields as sent to the server. Someone who cannot refund carries zero limits. */
export const refundFieldsForSave = (auth) => {
  const canRefund = !!auth?.canRefund;
  return {
    canRefund,
    maxRefundPerTransaction: canRefund ? toAmount(auth?.maxRefundPerTransaction) : 0,
    dailyRefundLimit: canRefund ? toAmount(auth?.dailyRefundLimit) : 0,
  };
};

/** The sentence under the refund fields when something is wrong; null when the values can be saved. */
export const refundAuthorityProblem = (auth) => {
  if (!auth?.canRefund) return null;
  const perRefund = toAmount(auth.maxRefundPerTransaction);
  const daily = toAmount(auth.dailyRefundLimit);
  if (perRefund <= 0) return 'Set the maximum amount per refund.';
  if (perRefund > MAX_REFUND_ENTRY || daily > MAX_REFUND_ENTRY) return 'Refund limits cannot be more than 1,00,00,000.';
  if (daily > 0 && daily < perRefund) return 'The daily limit cannot be smaller than the limit for one refund.';
  return null;
};
